import { OutreachAccountPicker } from '@/modules/outreach-v2/components/OutreachAccountPicker';
import { OUTREACH_THEME } from '@/modules/job/components/manage/outreach/ui-kit';

/**
 * Outreach accounts — the owner's "Manage Accounts" destination (revamp §7).
 * Connect and manage the mailboxes / LinkedIn accounts campaigns send from, in
 * one org-level place; the in-tab account dropdown deep-links here. Reuses the
 * hub's `OutreachAccountPicker` (connect + caps + status) under the sleek
 * monochrome theme so it matches the redesigned Outreach tab.
 */
export function OutreachAccountsPage() {
	return (
		<div className="h-full overflow-y-auto">
			<div className={`${OUTREACH_THEME} mx-auto max-w-5xl p-8`}>
				<header className="mb-6">
					<h1 className="text-2xl font-semibold text-[#191919]">Outreach accounts</h1>
					<p className="mt-1 text-sm text-[#5F6165]">
						Connect and manage the mailboxes and LinkedIn accounts your campaigns send from. Safe sending limits
						are applied automatically to protect deliverability.
					</p>
				</header>
				<OutreachAccountPicker defaultExpanded showAnalytics />
			</div>
		</div>
	);
}
